import { useState } from 'react';
import { Row, Col, Container } from 'react-bootstrap';
import CheckoutLayout from '../checkoutLayout/CheckoutLayout';
import {
  HeadingDescVsmall,
  SectionHeadingMed
} from '../../../Components/Headings';
import AddMember from '../../../Components/addMember/AddMember';
import CustomSelect2 from '../../../Components/customSelect2/CustomSelect2';
import checkIcon from '../../../assets/images/svg/check-green.svg';
import {
  AncerWithUnderlineSmall,
  SimpleAncerSmall
} from '../../../Components/button';
import infoIcon from '../../../assets/images/svg/info-gray-round.svg';
import './reviewAndBook.css';
import { AddPatientModal } from '../../../Components/customModals';

const reasonForConsultation = [
  { label: 'Regular Check up', value: 'regular check up' },
  { label: 'Monthly Check up', value: 'monthly check up' }
];

const typeOfAppoinment = [
  { label: 'Video', value: 'video' },
  { label: 'Chat', value: 'chat' }
];

const appoinmentaTime = [
  { label: 'Wed Apr 7 - 9:45 am', value: 'Wed Apr 7 - 9:45 am' },
  { label: 'Thu Apr 8 - 10:45 am', value: 'Thu Apr 8 - 10:45 am' }
];

function ReviewAndBook() {
  const [modal, setModal] = useState('false');
  return (
    <section className="reviewAndBook">
      <CheckoutLayout>
        <Container>
          <Row>
            <Col md={10}>
              <SectionHeadingMed text="Review and Book" />
              <form className="form">
                <Row>
                  <Col md={6}>
                    <div className="inputBox">
                      <AddMember
                        onClick={() => setModal('m1')}
                        labelText="Who will be seeing the doctor?*"
                      />
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className="inputBox">
                      <HeadingDescVsmall text="Phone number where the doctor can reach you*" />
                      <div className="phone_detail">
                        <div className="input_box">
                          <span>+92 </span>
                          <input
                            placeholder=""
                            className="custom_input"
                            type="text"
                          />
                        </div>
                      </div>
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className="inputBox">
                      <HeadingDescVsmall text="Phone number where the doctor can reach you*" />
                      <CustomSelect2
                        options={typeOfAppoinment}
                        defaultValue={typeOfAppoinment[0]}
                      />
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className="inputBox">
                      <HeadingDescVsmall text="Phone number where the doctor can reach you*" />
                      <CustomSelect2
                        options={reasonForConsultation}
                        defaultValue={reasonForConsultation[0]}
                      />
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className="inputBox">
                      <HeadingDescVsmall text="Have you seen the doctor before?*" />
                      <div className="radioContainer">
                        <div>
                          <div className="custom__radio check">
                            <input
                              type="radio"
                              name="custom"
                              id="yes"
                              checked
                            />
                            <label htmlFor="yes">
                              <img src={checkIcon} alt="checkIcon" />
                            </label>
                          </div>
                          Yes
                        </div>
                        <div>
                          <div className="custom__radio check">
                            <input type="radio" name="custom" id="no" />
                            <label htmlFor="no">
                              <img src={checkIcon} alt="checkIcon" />
                            </label>
                          </div>
                          No
                        </div>
                      </div>
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className="inputBox appointmentTime">
                      <HeadingDescVsmall text="Appointment Time*" />
                      <CustomSelect2
                        text={<AncerWithUnderlineSmall text="edit" />}
                        options={appoinmentaTime}
                        defaultValue={appoinmentaTime[0]}
                      />
                    </div>
                  </Col>
                  <Col md={12}>
                    <div className="inputBox">
                      <div className="textAreaContainer">
                        <HeadingDescVsmall text="Notes for the doctor’s office (optional)" />
                        <img src={infoIcon} alt="infoIcon" />
                      </div>
                      <textarea rows="4" className="customTextArea" />
                    </div>
                  </Col>
                  <Col md={5}>
                    <SimpleAncerSmall
                      to="/selectpaymentMethod"
                      text="CONFIRM BOOKING"
                    />
                  </Col>
                </Row>
              </form>
            </Col>
          </Row>
          <AddPatientModal
            show={modal === 'm1'}
            close={() => setModal(false)}
          />
        </Container>
      </CheckoutLayout>
    </section>
  );
}
export default ReviewAndBook;
